import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import {MenuButton as MenuButtonBase, SidebarPanel} from "@awe-web/shared/lib";
import UserNavigation from "./user_navigation";
import {AppNavigationLinks} from "./app_navigation.js";
import LanguageSwitch from "../l10n/components/language_switch";

import "./sidebar_menu.scss";

import closeIcon from "./assets/close.svg";

export function MenuButton({className}) {
  const combinedClassName = classnames("menu-button", className);
  return <MenuButtonBase className={combinedClassName} />;
}

MenuButton.propTypes = {
  className: PropTypes.string
};

export function SidebarMenu() {
  return (
    <SidebarPanel
      right
      disableAutoFocus
      outerContainerId={SidebarMenu.outerContainerId}
      pageWrapId={SidebarMenu.pageWrapId}
      customCrossIcon={<img src={closeIcon} alt="" />}
      htmlClassName="sidebar-menu__html"
    >
      <LanguageSwitch className="sidebar-menu__language-switch" />
      <UserNavigation className="sidebar-menu__user-navigation" />
      <AppNavigationLinks
        className="sidebar-menu__app-navigation-links"
        itemClassName="sidebar-menu__app-navigation-links__item"
        linkClassName="sidebar-menu__app-navigation-links__link"
        activeLinkClassName="sidebar-menu__app-navigation-links__link--active"
        linkTextClassName="sidebar-menu__app-navigation-links__link-text"
      />
    </SidebarPanel>
  );
}

SidebarMenu.outerContainerId = "sidebar-menu-container";
SidebarMenu.pageWrapId = "sidebar-menu-page";
